import { createFileRoute } from "@tanstack/react-router";
import { Card, PageHeading } from "@/ui";
import { DomainCard } from "#/components/domains/DomainCard";

// Settings > Domain — the single surface for the workspace's one domain.
//
// This page used to compose four surfaces built on the pre-#707 model: a
// paginated pool of sending domains (`DomainsTable`), its "New domain" dialog
// trigger, a separate "Publication domain" card claiming a second domain, and
// the staged-cutover panel. Epic #707 replaced that model with one domain per
// workspace doing two jobs — authenticating outbound mail, and optionally
// serving the blog on that same domain — but only Settings was updated (#743),
// so the two pages contradicted each other. This page now renders the same
// lifecycle card Settings' Domain card used to, and owns it.
//
// The staged-cutover flow (#710/#711) is gone from the UI deliberately: moving
// a blog domain destroys its SEO regardless, so a zero-downtime cutover buys
// minutes of uptime and no traffic. Changing domains is Disconnect -> Connect.
// Its procedures remain live on the router, uncalled — removing them would be a
// backwards-incompatible API change needing a coordinated rollout.
export const Route = createFileRoute("/dashboard/w/$workspaceId/domains")({
  component: DomainsRoute,
});

function DomainsRoute() {
  const { workspaceId } = Route.useParams();
  return <DomainsPage workspaceId={workspaceId} />;
}

export function DomainsPage({ workspaceId }: { workspaceId: string }) {
  return (
    <div className="flex flex-col gap-6">
      <PageHeading
        title="Domain"
        lede="Choose your GoodSender blog address in Blog → Configuration. Connect and verify one domain you control when you want to send customer email from it or serve your blog there."
      />

      {/* Unlabelled panel: the card used to be titled "Your domain", above a
          line that then named the domain — a heading and its own answer, one
          under the other. The domain IS the title, so it takes the heading
          treatment inside `DomainCard` and this wrapper adds nothing but the
          surface (product feedback, 2026-08-29). */}
      <Card>
        <DomainCard workspaceId={workspaceId} />
      </Card>
    </div>
  );
}
